import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Auth, confirmPasswordReset } from '@angular/fire/auth';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { verifyPasswordResetCode } from 'firebase/auth';
import { take } from 'rxjs';

@Component({
    selector: 'app-reset-password',
    imports: [FormsModule, CommonModule],
    templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent {
  isSuccessfull = false;
  details?: ResetPasswordData;
  password?: string;
  confirmNewPassword?: string;
  email?: string;
  /** Set when the link itself is bad/expired (verify failed). */
  linkError = '';
  private auth: Auth = inject(Auth);

  constructor(private route: ActivatedRoute, private router: Router) {
    this.route.queryParams.pipe(take(1)).subscribe(async (params) => {
      this.details = { ...params } as ResetPasswordData;
      // Identity Platform: the action link carries &tenantId=<pool>. The oobCode is pool-scoped, so
      // verify/confirm must run against that same pool (null = default pool / pre-migration links).
      (this.auth as any).tenantId = this.details?.tenantId || null;
      try {
        this.email = await verifyPasswordResetCode(
          this.auth,
          this.details?.oobCode || ''
        );
      } catch (error) {
        this.linkError =
          'This reset link is invalid or has expired. Please request a new one from the login page.';
      }
    });
  }
  async resetPassword() {
    if (this.confirmNewPassword !== this.password) {
      alert('Passwords do not match');
      return;
    }
    try {
      // Re-assert the pool (the shared Auth instance may have been retargeted elsewhere).
      (this.auth as any).tenantId = this.details?.tenantId || null;
      await confirmPasswordReset(
        this.auth,
        this.details?.oobCode || '',
        this.password || ''
      );
      this.isSuccessfull = true;
    } catch (error) {
      this.linkError =
        'Could not reset your password — the link may have expired. Please request a new one.';
    }
  }

  navigateHome() {
    this.router.navigate(['/']);
  }
}

interface ResetPasswordData {
  mode: string;
  oobCode: string;
  apiKey: string;
  /** Identity Platform pool the link was issued for; appended by Identity Platform. */
  tenantId?: string;
}
